/**
 * Executes a promise or async function and returns the result
 * @template T - The type of the resolved value
 * @param {Promise<T> | ((...args: any[]) => Promise<T>)} promiseOrAsyncFunc - A promise or function that returns a promise
 * @returns {Promise<T>} The promise result
 * @description Utility to normalize handling of promises and async functions
 */
export function run<T>(promiseOrAsyncFunc: Promise<T> | ((...args: any[]) => Promise<T>)): Promise<T> {
  if (typeof promiseOrAsyncFunc === `function`) {
    return promiseOrAsyncFunc()
  } else {
    return promiseOrAsyncFunc
  }
}
